var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.09961 8.21045H15.1455V8.98682H8.09961V16.355H7.29395V8.98682H0.526367V8.21045H7.29395V0.827637H8.09961V8.21045Z","fill":"#828282"}));
}

Plus.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
